module.exports = __webpack_public_path__ + "static/media/construction.db343c71.jpg";